export function capitalizeWords(str) {
  if (!str) {
    return str;
  }
  return str.split(' ').map(token => `${token[0].toUpperCase()}${token.substring(1).toLowerCase()}`).join(' ');
}